import { NgModule } from '@angular/core';

import { AbastecimentoBensComponent } from './abastecimento-bens.component';
import { AbastecimentoBemFormComponent } from './abastecimento-bem-form/abastecimento-bem-form.component';
import { AbastecimentoBemListComponent } from './abastecimento-bem-list/abastecimento-bem-list.component';
import { SharedModule } from "../../shared/shared.module";
import { AbastecimentoBensRoutingModule } from "./abastecimento-bens-routing.module";
import { AbastecimentoBemApiService } from "./shared/abastecimento-bem-api.service";
import { AbastecimentoBemNavigationService } from "./shared/abastecimento-bem-navigation.service";
import { AbastecimentoBemService } from "./shared/abastecimento-bem.service";
import {OdometrosHorimetrosModule} from "../../manutencoes/odometros-horimetros/odometros-horimetros.module";

@NgModule({
    imports: [
        SharedModule,
        OdometrosHorimetrosModule,
        AbastecimentoBensRoutingModule
    ],
    providers: [
        AbastecimentoBemApiService,
        AbastecimentoBemNavigationService,
        AbastecimentoBemService
    ],
    declarations: [
        AbastecimentoBensComponent,
        AbastecimentoBemFormComponent,
        AbastecimentoBemListComponent
    ]
})
export class AbastecimentoBensModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/abastecimento-bens.module.ts
 **/